import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PdfMarkupState, DocumentMarkupState, emptyDocumentState } from '@app/core/store/reducers/pdf-markup';

const getPdfMarkupFeatureState = createFeatureSelector<PdfMarkupState>('pdfMarkup');

export const getMarkupStateForDocument = (documentId: string) =>
  createSelector(
    getPdfMarkupFeatureState,
    (state: PdfMarkupState): DocumentMarkupState => state.byDocument[documentId] ?? emptyDocumentState,
  );
